import axios from "axios";
import { api } from "./helper";
const client = axios.create({
  baseURL: api,
  withCredentials: false
});

function Auth(id) {
  return client.get("Token/" + id);
}

export {
  Auth,
};
